export default class OwnerJointTenantOwner {
    id: number;
    prefix: string;
    firstName: string;
    lastName: string;
    middleName: string;
    suffix: string;
    aka: string;
    spousePrefix: string;
    spouseLastName: string;
    spouseMiddleName: string;
    spouseFirstName: string;
    spouseSuffix: string;
    spouseAka: string;
    maritalStatus: string;
    maritalStatusId: number;
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zipCode: string;
    email: string;
    phoneNumber: string;
    ssnTaxId: string;
}


// WEBPACK FOOTER //
// ./src/models/tract_detail/add_ownership_revised/OwnerJointTenantOwner.ts